import { FSMessage } from "src/common/keys/protos/collections_pb";
import {
  WatchedLogsEntity, WatchedLogEntity, GenericEntryEntity, DirectoryPaginationInfo, WatchedNodeLog, dayjs, WatchLogEvents, WatchLogActionsType, DriveEntryTypes, DriveEntryType,
  buildNavigationLink, buildWatchedNavigationLink, DriveConstants, WatchLogDetailedEvents
} from "src/common";
import _ from "lodash";

export class WatchedLogList implements WatchedLogsEntity {
    entries!: WatchedLogEntity[];
    pagination_info!: DirectoryPaginationInfo;
    readonly _nodes!: FSMessage.WatchedNodeLog[];
    constructor(message: FSMessage) {
        this._nodes = message.getWatchedNodeLogsList();
        this.setPaginationInfo(this._nodes.length);
    }

    get item(): WatchedLogsEntity {
        return {
            entries: this.entries,
            pagination_info: this.pagination_info,
        };
    }

    // Set pagination after it fetches
    public setPaginationInfo(total_count: number) {
        this.pagination_info = {
            total_count
        };
    }
}


export class WatchedLogEntry implements WatchedLogEntity {
    id!: string;
    collection_id!: string;
    maintainer_id?: string;
    action!: WatchLogActionsType;
    event!: string;
    user_id!: string;
    account_version!: number;
    last_modification_date!: string; // entryTs
    name!: string; // GenericEntryEntity extended
    type!: DriveEntryTypes;
    type_class?: string;
    metadata?: string;
    is_deleted?: boolean;
    url!: string; // Build url to node in MyPreVeil
    node!: GenericEntryEntity;
    constructor(log: WatchedNodeLog, node: GenericEntryEntity, public is_error?: boolean, detailed: boolean = false) {
        this.node = node;
        this.id = log.getNodeId_asB64();
        this.collection_id = log.getCollectionId_asB64();
        this.maintainer_id = node.maintainer_id;
        this.account_version = log.getAccountVersion() || 0;
        this.action = log.getAction() as WatchLogActionsType;
        this.event = this._buildEventLabel(this.action, detailed) || "";
        this.metadata = log.getMetadata();
        this.user_id = log.getCanonicalUserId() || "";
        const _latest_date = log.getEntryTs();
        this.last_modification_date = _latest_date && dayjs(_latest_date).isValid() ? dayjs.utc(_latest_date).local().format("MM/DD/YYYY h:mm A") : "";
        this.name = node.name;
        this.type = node.type;
        this.type_class = node.type_class;
        this.is_deleted = this.event === WatchLogEvents.delete_collection_node;
        this.url = this._getEntityURLbyType(node);
    }

    // Description: Build event friendly label from string action
    // @logged_actions[ create_collection_node, update_collection, delete_collection_node,rename_collection, acl_change ]
    private _buildEventLabel(action?: WatchLogActionsType, detailed: boolean = false): string {
        const event_label_map = detailed ? WatchLogDetailedEvents : WatchLogEvents;
        return !!action && _.has(event_label_map, action) ? event_label_map[action] : "";
    }

    // Description: build nodes url to MyPreVeil by DriveEntryType
    private _getEntityURLbyType(_entry: GenericEntryEntity): string {
        // NOTE: For disjointed acl nodes use direct link url with "list" in place of id
        const is_acl_node = !!_entry.parent_id && _entry.type === DriveEntryType.ACL_NODE;
        return (_entry.type === DriveEntryType.FILE && !!_entry.parent_id) ?
            buildNavigationLink(_entry.collection_id, _entry.parent_id, _entry.type, _entry.id) :
            _entry.type !== DriveEntryType.FILE ?
                buildNavigationLink(_entry.collection_id, is_acl_node ? DriveConstants.DIRECT_LINK_MASK_ID : _entry.id, !is_acl_node ? DriveEntryType.DIR : _entry.type) :
                buildWatchedNavigationLink(this.collection_id, this.id);
    }

    get item(): WatchedLogEntity {
        return {
            id: this.id,
            collection_id: this.collection_id,
            maintainer_id: this.maintainer_id,
            action: this.action,
            event: this.event,
            node: this.node,
            user_id: this.user_id,
            account_version: this.account_version,
            last_modification_date: this.last_modification_date,
            metadata: this.metadata,
            name: this.name,
            type: this.type,
            type_class: this.type_class,
            is_deleted: this.is_deleted,
            url: this.url,
            is_error: this.is_error
        };
    }
}